const monthsLabels: string[] = ['Janeiro', 'Fevereiro', 'Março',
    'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro',
    'Novembro', 'Dezembro'];

export class MonthModel {

    public numeric: number;
    public label: string;
    public firstWeekdayInMonth: number;

    constructor(month: number, year: number) {
        this.numeric = month + 1;
        this.label = monthsLabels[month];
        this.firstWeekdayInMonth = new Date(year, month, 1).getDay();
    }
}